import React, { useState, useEffect } from "react";
import RightArrow from "../../../../../assets/images/RightArrow@2x.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../CustomComponents/Loader";
import { width } from "../../../../CustomComponents/DynamicCard/DynamicCardStyles";
import CustomTextInput from "../../../../CustomComponents/CustomtextInput";
import DynamicCard from "../../../../CustomComponents/DynamicCard";
import {
  appTheme,
  decimalValidation,
} from "../../../../../helpers/utils/Utils";
import {
  addLineBreaks,
  handleAmountInputLimitTo2decimal,
  handleAmountInputLimitTo2decimalForAmount,
  retrieveData,
} from "../../../../../utils";
import logFirebaseEvents from "../../../../LogFirebaseEvents";
import CardHeading from "../../../../CustomComponents/CardHeading";
import { use } from "react";
import { withOidcSecure } from "@axa-fr/react-oidc";
import {
  ADD_SAVING_GOALS,
  SAVING_CARD_CODE,
  STATUS_SUCCESS_CODE,
} from "../../../../../network/URLConstants";
import {
  GetApiHeadersWithBearer,
  PostRequest,
} from "../../../../../network/NetworkUtils";
 
import CustomRadioButton from "../../../../CustomComponents/CustomRadioButton";
import checkbox_fill from "../../../../../assets/images/Checkbox-blue.png";
 
const SavingGoalNotificationField = ({
  cardFooter,
  onBack,
  onNext,
  handleAmountInput,
  onSave,
  onSetSpendSenseAlertFun,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);
  const [amountError, setAmountError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isNext, setIsNext] = useState(false);
  const [amountValue, setAmountValue] = useState("");
  const accessTokenToApi = useSelector((state) => state.accessToken);
  const cards = useSelector((state) => JSON.parse(state.userCards));
  const amount = useSelector((state) => state.savingGoals.amount);
  const name = useSelector((state) => state.savingGoals.name);
  const date = useSelector((state) => state.savingGoals.targetDate);
  const RESmsg = useSelector((state) => state.savingGoalResonseMsg);
  const [responseMsg, setResponseMsg] = useState();
  const NotificationTypeSMS = useSelector((state) => state.savingGoals.sms);
  const [notificationError, setnotificationError] = useState(null);
  const NotificationTypeEmail = useSelector((state) => state.savingGoals.email);
  const [notificationArray, setNotificationArray] = useState([
    { displayText: t("text"), isSelected: NotificationTypeSMS },
    { displayText: t("email"), isSelected: NotificationTypeEmail },
  ]);
 
  const handleBackClick = () => {
    logFirebaseEvents(
      "Saving_Goals",
      "Back_Saving_Goals_Clicked",
      "Back_Saving_Goals_Clicked",
      "",
      ""
    );
    onBack("SavingGoalDateField");
  };
 
  const setNotificationFun = (option) => {
    debugger;
    const selectedIndex = notificationArray.findIndex(
      (item) => item.displayText === option.displayText
    );
    notificationArray[selectedIndex] = {
      ...option,
      isSelected: !option?.isSelected,
    };
    setNotificationArray([...notificationArray]);
    if (option.displayText === "Email") {
      dispatch({
        type: "SAVING_GOALS",
        payload: { key: "email", value: !option?.isSelected },
      });
    } else {
      dispatch({
        type: "SAVING_GOALS",
        payload: { key: "sms", value: !option?.isSelected },
      });
    }
  };
 
 
  const handleNextClick = () => {
    logFirebaseEvents(
      "Saving_Goals",
      "Next_Saving_Goals_Clicked",
      "Next_Saving_Goals_Clicked",
      "",
      ""
    );
    // if (!amount) setAmountError("Amount Required");
    // if (amount && !amountError) onNext("SavingGoalConfirmation");

    if (!NotificationTypeSMS && !NotificationTypeEmail) {
      setnotificationError('Choose Notification Type');
    } else {
      setnotificationError('');
      dispatch({ type: "SAVING_GOALS", payload: { key: "Date", value: "" } });
      onNext("SavingGoalConfirmation")
    }
  };
 
  const handleOnBlur = (event) => {
    if (!amount) setAmountError("amount Required");
    else if (amount <= 0) {
      setAmountError("Please enter amount greater than 0");
    } else if (amount) {
      const inputValue = event.target.value;
      const formattedAmount = handleAmountInputLimitTo2decimal(inputValue);
      const finalAmountVal = decimalValidation(formattedAmount);
      dispatch({
        type: "SAVING_GOALS",
        payload: {
          key: "Amount",
          value: finalAmountVal,
        },
      });
    } else setAmountError("");
  };
 
  const amountValidation = () => {
    if (!amount) setAmountError("amount Required");
    else if (amount <= 0) {
      setAmountError("Please enter amount greater than 0");
    } else if (
      amount.endsWith(".") ||
      (amount.includes(".") && amount.split(".")[1].length < 2)
    ) {
      setIsNext(false);
    } else {
      setAmountError(null);
      setIsNext(true);
    }
  };
  useEffect(() => {
    if (amount) amountValidation();
    if (!amount) setIsNext(false);
  }, [amount]);

    useEffect(()=>{
      if(!NotificationTypeSMS && !NotificationTypeEmail) setIsNext(false);
      else setIsNext(true);
    },[NotificationTypeSMS,NotificationTypeEmail])
 
  // useEffect(() => {
  //   dispatch({ type: "SAVING_GOALS", payload: { key: "Amount", value: "" } });
  // }, []);
 
  const children = () => {
    return (
      <>
        {/* {cardHeader} */}
        <div
          className="sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
         sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px]
              text-[var(--text-clrs)] mt-6 sm:mx-0 mx-4"
        >
          {t("Set_Saving_Goal_Finally")}{" "}
          <span className="text-[var(--text-body-clrs)]">
            {addLineBreaks(t("Set_Saving_Goal_Notifcation"))}
          </span>
        </div>
 
        <div className="w-full flex justify-center">
          <div className="sm:w-[80%] w-full">
            {/* BODY */}
            <div className="md:my-32 sm:my-16 mt-10 mb-[10rem] sm:mx-0 mx-4">
              <div className="sm:w-[50%] w-full flex flex-col justify-center">
                <CustomRadioButton
                  title={t("spending_alert_notification_title")}
                  options={notificationArray}
                  onSelect={setNotificationFun}
                  fillIcon={checkbox_fill}
                  nullIcon={appThemeData.shownullMarvel}
                  error={notificationError}
                />
                 <p className='mt-4 font-hanken-grotesk text-[var(--notify-type-clr)] 
                 text-[12px] leading-[30px] 
                  font-normal'>{t('standard_message')}</p>
              </div>
            </div>
          </div>
        </div>
        {/* FOOTER */}
 
        {cardFooter(handleBackClick, handleNextClick, "", "", isNext)}
      </>
    );
  };
  return (
    <>
      <DynamicCard
        header={false}
        CardRadius={true}
        cardWidth={width.homeCard}
        HeaderRadius={true}
        isWhite={appThemeData.isWhiteBgForCard}
        isDarkForKudzu={appThemeData.isDarkBgForCard}
        backgroundColor={"--cardHeading-bg"}
        HeaderContent={
          <>
            <CardHeading heading={t("Add_Saving_Goal")} />
          </>
        }
        footer={true}
      >
        {children()}
      </DynamicCard>
 
      {isLoading && <Loader />}
    </>
  );
};
 
export default withOidcSecure(SavingGoalNotificationField);